/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
const A = 1e-5, I = 3, N = 400, t = 0;
export {
  N as DEFAULT_ANIMATION_DURATION,
  I as LABEL_DECIMALS,
  A as MIN_RATIO,
  t as NO_ANIMATION
};
